import { Component, OnInit } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { ORDERED_GRADE_KEYS } from "../../../models/constants"
import { FacetingService } from "../../../services/faceting.service"
import { EduComponent } from "../../../utils/eduComponent"
import { fadeInXY } from "../../../utils/animations"

@Component({
    selector: "app-filter-by-grade",
    templateUrl: "./filter-by-grade.component.html",
    styleUrls: ["./filter-by-grade.component.scss"],
    animations: [fadeInXY],
    standalone: false,
})
export class FilterByGradeComponent extends EduComponent implements OnInit {
    public options: string[] = ORDERED_GRADE_KEYS
    public selectedGrades: string[] = []

    constructor(
        private route: ActivatedRoute,
        private facetingService: FacetingService
    ) {
        super()
    }

    public ngOnInit() {
        this.addSub(
            this.route.queryParams.subscribe(() => {
                const facets = this.facetingService.getSelectedFacets(this.route)
                this.selectedGrades = []
                facets.map((facet: string) => {
                    if (facet.indexOf("grades:") !== -1) {
                        this.selectedGrades = facet.split(":")[1].split(",")
                    }
                })
            })
        )
    }

    public changeGrade() {
        this.facetingService.addFilter(`grades:${this.selectedGrades.join(",")}`, this.route, true)
    }

    public removeLastGrade(event) {
        if (this.selectedGrades.length === 0) {
            this.facetingService.removeFilter("grades:" + event.value, this.route)
        }
    }
}
